import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {Grid, Typography} from '@mui/material';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const Accommodation = () => {
  const [fileLoading, setFileLoading] = useState(false);

  const {watch, setValue} = useFormContext();

  const values = watch('menus.navigations.accommodations') || {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Label
        </Typography>
        <RHFMultilingualField name={`menus.navigations.accommodations.label`} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Title One
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.titleOne`}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Description One
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.descriptionOne`}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Title Two
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.titleTwo`}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Description Two
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.descriptionTwo`}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Comfort Title
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.comfort.title`}
        />
        <Typography variant='h6' mb={2}>
          Comfort Description
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.comfort.description`}
        />

        <Typography variant='h6' mb={2}>
          Comfort Image
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 370, height: 300}}}
          name={'menus.navigations.accommodations.comfort.image'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.accommodations.comfort.image`, links[0])
          }
          destination={'landing-pages'}
          values={values?.comfort?.image}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Sensible Title
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.sensible.title`}
        />
        <Typography variant='h6' mb={2}>
          Sensible Description
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.sensible.description`}
        />

        <Typography variant='h6' mb={2}>
          Sensible Image
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 370, height: 300}}}
          name={'menus.navigations.accommodations.sensible.image'}
          setFileUrl={(links) =>
            setValue(
              `menus.navigations.accommodations.sensible.image`,
              links[0]
            )
          }
          destination={'landing-pages'}
          values={values?.sensible?.image}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Reliable Title
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.reliable.title`}
        />
        <Typography variant='h6' mb={2}>
          Reliable Description
        </Typography>
        <RHFMultilingualField
          name={`menus.navigations.accommodations.reliable.description`}
        />

        <Typography variant='h6' mb={2}>
          Reliable Image
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 370, height: 300}}}
          name={'menus.navigations.accommodations.reliable.image'}
          setFileUrl={(links) =>
            setValue(
              `menus.navigations.accommodations.reliable.image`,
              links[0]
            )
          }
          destination={'landing-pages'}
          values={values?.reliable?.image}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>
    </Grid>
  );
};
